import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "input-group-btn" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_9 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_10 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_11 = { class: "float-end left5" };
const _hoisted_12 = { class: "clearfix pad10" };
const _hoisted_13 = { class: "float-end" };
const _hoisted_14 = {
    key: 0,
    class: "float-end"
};
const _hoisted_15 = { class: "float-end hidden-xs record-count" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12" };
const _hoisted_17 = { class: "card bg-white data-grid alarm-types-grid detached overflow-x-auto" };
const _hoisted_18 = { class: "table table-hover table-fixed bottom0 pw100" };
const _hoisted_19 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_20 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_21 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_22 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_23 = { class: "text-center hidden-sm" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "clearfix visible-sm" };
const _hoisted_26 = { class: "clearfix" };
const _hoisted_27 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_28 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_29 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_30 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tAlarm Types\r\n\t\t\t\t")
            ]),
            _createTextVNode(),
            _createElementVNode("div", { class: "form-menu" }, [
                _createElementVNode("div", { class: "float-end" }, [
                    _createCommentVNode("<router-link :to=\"{ name: 'alarm-type' }\">\r\n\t\t\t\t\t\t<b-button variant=\"primary\">\r\n\t\t\t\t\t\t\t<span class=\"fa fa-plus\"></span><span class=\"hidden-xs\">&nbsp;Add Alarm Type</span>\r\n\t\t\t\t\t\t</b-button>\r\n\t\t\t\t\t</router-link>")
                ])
            ])
        ], -1 /* CACHED */)),
        _cache[39] || (_cache[39] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_7, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[4] || (_cache[4] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[18] || (_cache[18] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                    _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                                ]))]),
                                            default: _withCtx(() => [
                                                _cache[12] || (_cache[12] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: "includeDeleted",
                                                                    modelValue: _ctx.query.includeDeleted,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue"])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }),
                                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                            _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ], -1 /* CACHED */)),
                                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[14] || (_cache[14] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                    _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.query.pageNo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                                                "per-page": _ctx.query.pageSize,
                                                "total-rows": _ctx.data.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createCommentVNode("<div class=\"checkbox-wrapper\">\r\n\t\t<b-form-checkbox id=\"includeArchived\" v-model=\"query.includeDeleted\" size=\"lg\"></b-form-checkbox>\r\n\t\t<label for=\"includeArchived\">\r\n\t\t\tShow archived\r\n\t\t</label>\r\n\t</div>")
                    ])
                ]),
                _cache[37] || (_cache[37] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("table", _hoisted_18, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('alarmTypeName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_19))
                                        : _createCommentVNode("v-if", true),
                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'AlarmTypeName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    (_ctx.isVisible('scopeName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_20, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'AlarmScope.AlarmScopeName', title: 'Scope' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    (_ctx.isVisible('measurementTypeName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'MeasurementType.MeasurementTypeName', title: 'Measurement' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    (_ctx.isVisible('stringStatusName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'StringStatus.StatusName', title: 'String Status' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[35] || (_cache[35] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_23, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[24] || (_cache[24] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[25] || (_cache[25] = _createTextVNode()),
                                                            _createCommentVNode("<b-dropdown-item v-show=\"!item.whenDeleted\" @click=\"archive(item)\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"fa fa-trash\"></span>&nbsp;Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t</b-dropdown-item>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<b-dropdown-item v-show=\"item.whenDeleted\" @click=\"restore(item)\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"fa fa-refresh\"></span>&nbsp;Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t</b-dropdown-item>")
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[30] || (_cache[30] = _createTextVNode()),
                                        (_ctx.isVisible('alarmTypeName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'alarm-type', params: { 'id': item.alarmTypeId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.alarmTypeName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _cache[29] || (_cache[29] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'alarm-type', params: { 'id': item.alarmTypeId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.alarmTypeName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _withDirectives(_createElementVNode("div", { class: "clearfix" }, _toDisplayString(item.scopeName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.scopeName]
                                                        ]),
                                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, _toDisplayString(item.measurementTypeName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.measurementTypeName]
                                                        ]),
                                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, _toDisplayString(item.stringStatusName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.StringStatusName]
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[31] || (_cache[31] = _createTextVNode()),
                                        (_ctx.isVisible('scopeName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(item.scopeName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[32] || (_cache[32] = _createTextVNode()),
                                        (_ctx.isVisible('measurementTypeName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(item.measurementTypeName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[33] || (_cache[33] = _createTextVNode()),
                                        (_ctx.isVisible('stringStatusName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(item.stringStatusName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[36] || (_cache[36] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [...(_cache[34] || (_cache[34] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "6"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
